import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { Layout, ConfigProvider, theme } from 'antd';
import { useLocation, useSearchParams } from 'react-router-dom';
import { customDarkTheme, customLightTheme, customLightMuiTheme } from "./themeConfig";
import {IAPlatformRoutes, IQPlatformRoutes} from "./Configs/AppRoutes";
import {PublicRoutes} from "./Configs/AppRoutes";
import { AuthContext } from './Contexts/AuthContext';
import { PortfolioProvider } from './Contexts/PortfolioContext';
import { BuilderProvider } from "./Contexts/BuilderContext";
import { ClientProvider } from './Contexts/ClientContext'; // Adjust the path as necessary
import {ThemeProvider} from "@mui/material/styles";
import Disclaimer from "./Components/Disclaimer";
import SideBar from "./Layouts/SideBar";
import EntryPortal from "./Pages/Entry/EntryPortal";
import {filterAppsForUser} from "./Configs/AppsConfig";
import 'react-form-builder2/dist/app.css';
const { Content, Sider } = Layout;


const ConditionalSideBar = ({ collapsed, setCollapsed }) => {
    const location = useLocation();
    return location.pathname !== '/' ? <SideBar
        className={'themed-sider'}
        collapsed={collapsed} setCollapsed={setCollapsed} /> : null;
};


const IAPlatformApp = ({collapsed, setCollapsed, keys})=>{
    let widgets = filterAppsForUser(keys);

    return (
        <PortfolioProvider>
            <BuilderProvider>
                <ConfigProvider theme={customLightTheme}>
                    <ThemeProvider theme={customLightMuiTheme}>
                        <ClientProvider>
                            <Layout style={{minHeight: '100vh'}}>
                                <ConditionalSideBar collapsed={collapsed} setCollapsed={setCollapsed} />
                                <Layout className="site-layout">
                                    <Content style={{
                                        margin: '0',
                                        height: '100vh',
                                        overflow: 'auto',
                                        background: "transparent"
                                    }}>
                                        <div className="site-layout-background" style={{height: '100%', overflowY: 'auto'}}>
                                            <IAPlatformRoutes widgets={widgets} />
                                        </div>
                                    </Content>
                                </Layout>
                            </Layout>
                        </ClientProvider>
                    </ThemeProvider>
                </ConfigProvider>
            </BuilderProvider>
        </PortfolioProvider>
    )
}

const IQPlatformApp = ({collapsed, setCollapsed})=>{
    return (
            <ConfigProvider theme={customLightTheme}>
                <ThemeProvider theme={customLightMuiTheme}>
                    <Layout style={{ minHeight: '100vh' }}>
                        <ConditionalSideBar collapsed={collapsed} setCollapsed={setCollapsed} />
                        <Layout className="site-layout">
                            <Content style={{
                                        margin: '0',
                                        height: '100vh',
                                        overflow: 'auto',
                                        background: "#FFFFFF"
                            }}>
                                <div className="site-layout-background" style={{height: '100%', overflowY: 'auto'}}>
                                    <IQPlatformRoutes />
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </ThemeProvider>
            </ConfigProvider>
    )
}


const PublicApp = ()=>{
    return (
        <ConfigProvider theme={customLightTheme}>
            <ThemeProvider theme={customLightMuiTheme}>
                <PublicRoutes />
            </ThemeProvider>
        </ConfigProvider>
    )
}


const BrandedHelmet = ({title})=>{
    return (
        <Helmet>
            <link rel={'icon'} href={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/finiat-f-black.ico'} />
            <title>{title}</title>
        </Helmet>
    )
}


function App() {
    const { isLoggedIn } = useContext(AuthContext);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [collapsed, setCollapsed] = useState(true); // State to control the collapse
    const [agreementConfirmed, setAgreementConirmed] = useState(false);
    const accountType = localStorage.getItem('acct_type');
    const isPublicRoute = location.pathname.startsWith('/public');
    const userApps = localStorage.getItem('apps');


    if (isPublicRoute) {
        return <PublicApp />
    }
    console.log('isLoggedIn', isLoggedIn)

    if (!isLoggedIn) {
        return (
            <>
                <BrandedHelmet title={'IA Login'} />

                <EntryPortal
                    initialView={searchParams.get('setView')}
                    prospect={searchParams.has('isProspect')}
                />
            </>
        )
    }


    const handleAgreement = () => {
        setAgreementConirmed(true);
    };

    if (!agreementConfirmed) {
        return (
        <ConfigProvider theme={customLightTheme}>
            <ThemeProvider theme={customLightMuiTheme}>
                <BrandedHelmet title={'FINIAT Disclaimer'} />
                <Disclaimer onAgree={handleAgreement} />
            </ThemeProvider>
        </ConfigProvider>
        );
    }

    return (
        <>
            <BrandedHelmet title={'Finiat'} />
            {accountType === 'platform' && <IAPlatformApp {...{collapsed, setCollapsed}} keys={userApps} />}
            {accountType === 'iq' && <IQPlatformApp {...{collapsed, setCollapsed}} />}
        </>
    );
}

export default App;
